import { FormHelperText, Grid, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { Controller, useWatch } from "react-hook-form";
import Competence from "constants/Competence";
import NewTransfertPorteesEauAss from "./NewTransfertPorteesEauAss";
import NewTransfertPorteesGce from "./NewTransfertPorteesGce";
import NewTransfertPorteesGepu from "./NewTransfertPorteesGepu";
import type { CreateTransfertsModelForm } from "models";

function NewTransfertPortees(): ReactNode {
  const competence = useWatch<CreateTransfertsModelForm, "perimetre.competence">({
    name: "perimetre.competence",
  });

  if (competence == null) {
    return (
      <Grid container spacing={2} size={12}>
        <Typography color="error">Veuillez d'abord sélectionner un périmètre plus haut.</Typography>
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} size={12}>
      <Grid size={12}>
        {competence === Competence.GEPU && (
          <Controller
            name="codeTransfertsEauAssGepu"
            rules={{
              required: "Il est obligatoire de sélectionner la compétence",
              validate: (value: Array<string>) => value.length > 0,
            }}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <Grid container spacing={2}>
                <NewTransfertPorteesGepu value={value} onChange={onChange} />
                {error != null && <FormHelperText error>{error.message}</FormHelperText>}
              </Grid>
            )}
          />
        )}
        {competence === Competence.GCE && (
          <Controller
            name="codeTransfertsGce"
            rules={{
              required: "Il est obligatoire de sélectionner au moins une sous-compétence ou portée",
              validate: (value) => value.length > 0,
            }}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <Grid container spacing={2}>
                <NewTransfertPorteesGce value={value} onChange={onChange} competence={competence} />
                {error != null && <FormHelperText error>{error.message}</FormHelperText>}
              </Grid>
            )}
          />
        )}
        {[Competence.EAU, Competence.ASS].includes(competence) && (
          <Controller
            name="codeTransfertsEauAssGepu"
            rules={{
              required: "Il est obligatoire de sélectionner au moins une sous-compétence ou portée",
              validate: (value: Array<string>) => value.length > 0,
            }}
            render={({ field: { value, onChange }, fieldState: { error } }) => (
              <Grid container spacing={2}>
                <NewTransfertPorteesEauAss
                  value={value}
                  onChange={onChange}
                  competence={competence}
                />
                {error != null && <FormHelperText error>{error.message}</FormHelperText>}
              </Grid>
            )}
          />
        )}
      </Grid>
    </Grid>
  );
}

export default NewTransfertPortees;
